import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { isRunningInNativeApp, native } from '@lemoment/shared';

import { en } from './en';
import { ko } from './ko';

const nativeAppDetector = {
  name: 'nativeApp',
  lookup: (): string | undefined => {
    const info = window.__LEMOMENT_DEVICE_INFO__;
    if (!info?.locale) {
      return undefined;
    }
    // 'ko-KR' -> 'ko', 'en-US' -> 'en'
    return info.locale.split('-')[0];
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(nativeAppDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
    },
    fallbackLng: 'ko',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'nativeApp', 'navigator'],
      lookupLocalStorage: 'lemoment_language',
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (language: string) => {
  if (isRunningInNativeApp()) {
    native.notify('languageChanged', { language });
  }
});

export { i18n };
